import React, { useState } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import PropTypes from 'prop-types';
import clsx from 'clsx';

// modules
import moment from 'moment';

// ui/ux
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import TableSortLabel from '@material-ui/core/TableSortLabel';

const useStyles = makeStyles({
  pointer: {
    cursor: 'pointer'
  },
  table: {
    minHeight: '300px'
  }
});

const GenericTable = /* React.forwardRef( */ (props) => {
  // const theme = useTheme();
  const classes = useStyles();
  const { data, onSelect, struct, superStruct, maxContent } = props;

  const [sortOrder, setSortOrder] = useState(props.defaultSortOrder || 'asc');
  const [sortColumn, setSortColumn] = useState(props.defaultSort || 'id');

  const sortedData = data.sort((a, b) => {
    a = a[sortColumn];
    b = b[sortColumn];

    if (sortColumn.endsWith('_at')) {
      a = moment(a);
      b = moment(b);
      if (a === b) return 0;
      if (a > b) {
        return sortOrder === 'asc' ? 1 : -1;
      } else {
        return sortOrder === 'asc' ? -1 : 1;
      }
    } else if (typeof a === 'string') {
      return sortOrder === 'asc' ? a.localeCompare(b) : b.localeCompare(a);
    } else if (typeof a === 'number') {
      if (a === b) return 0;
      if (a > b) {
        return sortOrder === 'asc' ? 1 : -1;
      } else {
        return sortOrder === 'asc' ? -1 : 1;
      }
    } else {
      return 0;
    }
  });

  return (
    <TableContainer className={classes.table}>
      <Table size="small" className={'noselect'} style={{ width: maxContent ? 'max-content' : null }}>
        {superStruct ? (
          <TableHead>
            <TableRow>
              {superStruct.map((d) => {
                return (
                  <TableCell key={d.id} {...d.args} style={{ ...d.style }}>
                    {d.name}
                  </TableCell>
                );
              })}
            </TableRow>
          </TableHead>
        ) : null}
        <TableHead>
          <TableRow>
            {struct.map((d) => {
              return (
                <TableCell key={d.id} {...d.args} style={{ ...d.style }}>
                  <TableSortLabel
                    active={sortColumn === d.id}
                    direction={sortOrder}
                    onClick={() => {
                      if (sortColumn === d.id) {
                        setSortOrder(sortOrder === 'asc' ? 'desc' : 'asc');
                      }
                      setSortColumn(d.id);
                    }}
                  >
                    {d.name}
                  </TableSortLabel>
                </TableCell>
              );
            })}
          </TableRow>
        </TableHead>
        <TableBody>
          {sortedData.map((row) => (
            <TableRow
              style={row['#row-style']}
              key={row.id}
              hover
              className={clsx(onSelect && classes.pointer)}
              onClick={() => {
                onSelect && onSelect(row);
              }}
            >
              {struct.map((d, i) => {
                const k = d.id;
                const v = row[k];
                const t = row[k + '#title'] || null;
                const contentFn = row['#cell-func'] && row['#cell-func'][k];

                return (
                  <TableCell style={{ ...row['#cell-style'], ...d.style }} key={k} title={t} component={i === 0 ? 'th' : null} scope={i === 0 ? 'row' : null} {...d.args}>
                    {contentFn ? contentFn(row, d) : v}
                  </TableCell>
                );
              })}
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
};

GenericTable.propTypes = {
  data: PropTypes.array.isRequired,
  superStruct: PropTypes.array,
  struct: PropTypes.array.isRequired,
  maxContent: PropTypes.bool,

  onSelect: PropTypes.func,
  defaultSort: PropTypes.string,
  defaultSortOrder: PropTypes.string
};

GenericTable.defaultProps = {
  maxContent: false
};

export default GenericTable;
